import {
  API,
  Request
} from '@/lib/index.js'

export default {
  namespaced: true,
  state: {
    openSearch: false,
    suggesterList: [],
    hotKeywords: [],
    categories: [],
    enabledSearch: false,
    courseList: [],
    afterCourseId: 0,
    esId: undefined,
    score: undefined,
    historyList: []
  },
  mutations: {
    updateSearchStatus (state, payload = false) {
      state.openSearch = payload
    },
    updateCompletionSuggester (state, payload  = []) {
      state.suggesterList = payload || []
    },
    updateHotKeywords (state, payload  = []) {
      state.hotKeywords = payload || []
    },
    updateCategories (state, payload  = []) {
      state.categories = payload || []
    },
    updateSearchEnabled (state, payload  = false) {
      state.enabledSearch = payload || false
    },
    updateCourseList (state, {afterCourseId, searchedCourses}) {
      state.afterCourseId = afterCourseId
      let result = searchedCourses || []
      state.esId = result.length && result[result.length - 1].esId || undefined
      state.score = result.length && result[result.length - 1].score || undefined
      state.courseList = state.courseList.concat(result)
    },
    clearScore (state) {
      state.esId = undefined
      state.score = undefined
    },
    cleanCourseList (state) {
      state.afterCourseId = 0
      state.courseList = []
    },
    updateHistory (state, payload = []) {
      state.historyList = payload || []
    }
  },
  getters: {

  },
  actions: {
    getCompletionSuggester ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.getCompletionSuggester, {
          keyword: '' || payload
        }).then((resp) => {
          commit('updateCompletionSuggester', resp)
          resolve(resp)
        }).catch((resp) => {
          reject(resp)
        })
      })
    },
    getHotKeywords ({commit}, count = 10) {
      return new Promise((resolve, reject) => {
        Request(API.getHotKeywords, {
          count
        }).then((resp) => {
          commit('updateHotKeywords', resp)
          resolve(resp)
        }).catch((resp) => {
          reject(resp)
        })
      })
    },
    searchCourses ({state, commit}, {keyword, categoryId, afterKey, size}) {
      return new Promise((resolve, reject) => {
        Request(API.searchCourses, {
          searchConditionDTO: {
            keyword,
            categoryId,
            waterfall: {
              esId: state.esId,
              score: state.score,
              afterKey: afterKey || undefined, //	Integer	必填	起始页，从1开始
              size //	Integer	必填	每页的条数
            }
          }
        }).then((resp) => {
          commit('updateCourseList', resp)
          resolve(resp)
        }).catch((resp) => {
          reject(resp)
        })
      })
    },
    searchEnabled ({commit}) {
      return new Promise((resolve, reject) => {
        Request(API.searchEnabled, {
        }).then((resp) => {
          commit('updateSearchEnabled', resp)
          resolve(resp)
        }).catch((resp) => {
          reject(resp)
        })
      })
    },
    searchHistory ({commit}) {
      return new Promise((resolve, reject) => {
        Request(API.searchHistory, {
        }).then((resp) => {
          commit('updateHistory', resp)
          resolve(resp)
        }).catch((resp) => {
          reject(resp)
        })
      })
    },
    queryCoursePrimaryCategories ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.queryCoursePrimaryCategories, {
          keyword: payload
        }).then((resp) => {
          commit('updateCategories', resp || {})
          resolve(resp)
        }).catch((resp) => {
          reject(resp)
        })
      })
    }
  }
}
